import { render, staticRenderFns } from "./tblRecepturesTable.vue?vue&type=template&id=f5cc7e02"
import script from "./tblRecepturesTable.vue?vue&type=script&lang=js"
export * from "./tblRecepturesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports